module.exports = __webpack_public_path__ + "static/lake_aerial_8-5ad2568b7b250926ee3e092ba499ab64.jpg";